export default __webpack_public_path__ + "static/media/Soles of the Endless Sands.cc47b325.jpg";